/**
 * Gets the number of decimal points from a provided number.
 *
 * @param {number} value - The number to count decimal places for.
 * @returns {number} The number of decimal places.
 */
export const getDecimalCount = (value: number) => {
  return (String(value).split('.').at(1) || '').length;
};
